(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui-react/icon-message/assets/prescript.js') >= 0) return;  svs.modules.push('/components/tb-ui-react/icon-message/assets/prescript.js'); 'use strict';

svs.tb_ui_react = svs.tb_ui_react || {};
svs.tb_ui_react.icon_message = svs.tb_ui_react.icon_message || {};
 })(window);